import SearchUsers from "./search-users";

export default SearchUsers;